/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:25]
Permissions to update outside the main branch: [false]
*/

import { datetimeWithSecondsFormat } from 'constans/dateFormat';
import { endOfDay, format, startOfDay } from 'date-fns';

export function isDataTimeString(val: string) {
    const regExp =
        '^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])' +
        'T(2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9](.\\d+)?$';
    return val.match(regExp);
}

export function getEndOfTheDay(date = new Date()) {
    return format(endOfDay(date), datetimeWithSecondsFormat);
}

export function getStartOfTheDay(date = new Date()) {
    return format(startOfDay(date), datetimeWithSecondsFormat);
}
